var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        "min-width": "340",
        "max-width": "360",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "button",
                _vm._g(
                  {
                    staticClass: "tb-notif__bell",
                    attrs: { type: "button", title: "Notificações" }
                  },
                  on
                ),
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "bell",
                      size: _vm.BELL_SIZE,
                      color: "#030309"
                    }
                  }),
                  _vm.hasUnread
                    ? _c("span", { staticClass: "tb-notif__badge" }, [
                        _vm._v(_vm._s(_vm.unreadLabel))
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "tb-notif" }, [
        _c("header", { staticClass: "tb-notif__head" }, [
          _c("span", { staticClass: "tb-notif__title" }, [
            _vm._v("Notificações")
          ]),
          _vm.hasUnread
            ? _c("span", { staticClass: "tb-notif__count" }, [
                _vm._v(_vm._s(_vm.unreadLabel) + " não lidas")
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "tb-notif__list" },
          [
            _vm._l(_vm.preview, function(n) {
              return _c("div", { key: n.id, staticClass: "tb-notif__item" }, [
                _c("span", { staticClass: "tb-notif__dot" }),
                _c("div", { staticClass: "tb-notif__item-body" }, [
                  _c("span", { staticClass: "tb-notif__item-title" }, [
                    _vm._v(_vm._s(n.titulo))
                  ]),
                  n.corpo
                    ? _c("span", { staticClass: "tb-notif__item-text" }, [
                        _vm._v(_vm._s(n.corpo))
                      ])
                    : _vm._e()
                ])
              ])
            }),
            !_vm.preview.length
              ? _c("div", { staticClass: "tb-notif__empty" }, [
                  _vm._v(" Nenhuma notificação no momento. ")
                ])
              : _vm._e()
          ],
          2
        ),
        _c(
          "button",
          {
            staticClass: "tb-notif__all",
            attrs: { type: "button" },
            on: { click: _vm.verTodas }
          },
          [_vm._v("Ver todas")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }